import { api } from "app/utils/api";
import React, { createContext, useContext, useState } from "react";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("@app:user");
    const storedToken = localStorage.getItem("@app:token");

    if (storedUser && storedToken) {
      api.defaults.headers.Authorization = storedToken;
      return JSON.parse(storedUser);
    }

    return null;
  });

  const login = async (username, password) => {
    try {
      const response = await api.post("/auth/login", {
        username: username,
        password: password
      });

      const payload = response.data.data;

      const userPayload = {
        name: payload.name,
        username: payload.username,
        email: payload.email,
        type: payload.type,
        events: payload.events
      };

      const token = `Bearer ${payload.token}`;
      setUser(userPayload);

      api.defaults.headers.Authorization = token;
      localStorage.setItem("@app:user", JSON.stringify(userPayload));
      localStorage.setItem("@app:token", token);

      return userPayload;
    } catch (error) {
      if (error.message === "Network Error") {
        throw new Error("Erro de conexão com o servidor");
      } else {
        throw new Error("Credenciais inválidas");
      }
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("@app:user");
    localStorage.removeItem("@app:token");
  };

  const updateUser = (newUserData) => {
    setUser((prevUser) => ({
      ...prevUser,
      ...newUserData
    }));
  };

  const value = {
    login,
    logout,
    user,
    updateUser
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth deve ser usado dentro de um AuthProvider");
  }
  return context;
};

export default AuthProvider;
